import { useMutation } from "@tanstack/react-query";

import { confirmPayment } from "~/patients/api/payments";

export const useConfirmPayment = (onSuccess: () => void) => {
  return useMutation({
    mutationFn: confirmPayment,
    onSuccess,
  });
};
